import { useState, useEffect } from "react";
import { updateMyaccountCustomerDetails } from "../../../../../global/paywall/paywallApiUrls";
import * as axios from "axios";
import { setCurrentUser } from "../../../../../global/paywall/paywallUtils";


interface PersonalDetailsProps {
    userData: any;
    setUserData: (data: any) => void;
}

const CalcalistPaywallMyAccountPersonalDetails = (props: PersonalDetailsProps) => {

    const [formData, setFormData] = useState<any>({
        firstname: { id: 2, name: "firstname", type: "text", label: "שם פרטי", order: 1, value: "", isValid: false, error: "" },
        lastname: { id: 3, name: "lastname", type: "text", label: "שם משפחה", order: 2, value: "", isValid: false, error: "" },
        phone: { id: 4, name: "phone", type: "tel", inputmode: "numeric", pattern: "[0-9]*", order: 3, label: "מספר טלפון", isValid: false, value: "", error: "" },
        email: { id: 1, name: "email", type: "text", label: "משתמש", disabled: true, order: 4, value: "", isValid: false, error: "" },
    });

    const [generalError, setGeneralError] = useState("");
    const [isSubmitted, setIsSubmitted] = useState(false);
    const validationSchema = {
        email: {
            required: false,
            message: "שדה חובה",
            validate: (value: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) || "כתובת מייל לא תקינה",
        },
        firstname: {
            required: false,
            message: "שדה חובה",
            validate: (value: string) => {
                if (value.length > 50) return "שם פרטי יכול להכיל עד 50 תווים";
                return /^[A-Za-zא-ת\u0590-\u05FF' ]{2,}$/u.test(value) || "שם פרטי יכול להכיל רק אותיות";
            },
        },
        lastname: {
            required: false,
            message: "שדה חובה",
            validate: (value: string) => {
                if (value.length > 50) return "שם משפחה יכול להכיל עד 50 תווים";
                return /^[A-Za-zא-ת\u0590-\u05FF' ]{2,}$/u.test(value) || "שם משפחה יכול להכיל רק אותיות";
            },
        },
        phone: {
            required: true,
            message: "שדה חובה",
            validate: (value: string) => /^05\d{8}$/.test(value) || "מספר טלפון לא תקין",
        },
    };


    const validateField = (name: string, value: string): { isValid: boolean; error: string } => {
        const field = validationSchema[name];
        if (!field) return { isValid: false, error: "שדה לא מוכר" };
        if (field.required && !value.trim()) {
            return { isValid: false, error: field.message };
        }
        if (!field.required && value.trim() === '') {
            return { isValid: true, error: "" };
        }
        const isValid = field.validate(value) === true;
        const error = isValid ? "" : field.validate(value) as string;
        return { isValid, error };
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        const { isValid, error } = validateField(name, value);
        setIsSubmitted(false);
        setFormData(prev => ({
            ...prev,
            [name]: { ...prev[name], value, isValid, error }
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response: any = await updateUserData(formData);
            if (response) {
                setIsSubmitted(true);
            }
        } catch (error) {
            console.error("Error sending form data:", error);
            setGeneralError("שגיאה בשמירת הנתונים. אנא נסו שוב מאוחר יותר.");
            return;
        }
    };

    useEffect(() => {
        const data = props.userData;
        const phoneValidation = validateField("phone", data.phoneNumber || "");
        setFormData(prevFormData => ({
            ...prevFormData,
            email: { ...prevFormData.email, value: data.email },
            firstname: { ...prevFormData.firstname, value: data.firstName || "" },
            lastname: { ...prevFormData.lastname, value: data.lastName || "" },
            phone: { ...prevFormData.phone, value: data.phoneNumber || "", isValid: phoneValidation.isValid, error: phoneValidation.error },
        }));
    }, [])

    const updateUserData = async (data) => {
        const updatedDetails = {
            details: {
                firstName: data.firstname.value || " ",
                lastName: data.lastname.value || " ",
                phoneNumber: data.phone.value,
            },
        };
        try {
            const response = await axios.post(updateMyaccountCustomerDetails(), updatedDetails);
            if (response && response.status === 200) {
                const updatedUserData = {
                    ...props.userData,
                    firstName: updatedDetails.details.firstName,
                    lastName: updatedDetails.details.lastName,
                    phoneNumber: updatedDetails.details.phoneNumber,
                };
                setCurrentUser(formData);
                props.setUserData(updatedUserData);
                return response.data;
            }
        } catch (error) {
            console.error(error);
            setGeneralError("משהו השתבש, נסו שוב מאוחר יותר");
        }
    };


    const allFieldsValid = Object.values(formData).every((field: any) => !field.error);

    return (
        <div className="CalcalistPaywallMyAccountPersonalDetails">
            <div className="personal-details-form">
                <form id="checkout-personal-details" onSubmit={handleSubmit}>
                    {Object.keys(formData).map((field) => {
                        const inputField = formData[field];
                        return <div
                            className={`input-field ${field}`}
                            style={{ order: inputField.order }}
                            key={inputField.id}>
                            <label>{inputField.label}</label>
                            <input
                                placeholder={inputField.label}
                                disabled={inputField.disabled}
                                type={inputField.type}
                                name={inputField.name}
                                value={inputField.value}
                                onChange={handleChange}
                                className={inputField.error ? "error" : ""}
                            />
                            {<span className="input-field-error">{inputField.error}</span>}
                        </div>
                    })}
                </form>
                <div className="general-error">{generalError}</div>
                <button disabled={!allFieldsValid || isSubmitted} form="checkout-personal-details" className="submit-button" type="submit">שמירת שינויים</button>
                {isSubmitted && <div className="success-message">השינויים נשמרו בהצלחה!</div>}
            </div>

        </div>
    );
};

export default CalcalistPaywallMyAccountPersonalDetails;